import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const selectorBlogState = (state: RootState) => state.currentBlog;

export const selectorIsLoadingCurrentPost = createSelector(
  selectorBlogState,
  (blogState) => blogState.isLoading
);

export const selectorCurrentPost = createSelector(
  selectorBlogState,
  (blogState) => blogState.post
);
